module.exports = __webpack_public_path__ + "img/icon (5).8bf8c6d2.png";